
export function showNotif(show, type, message){
    return async function (dispatch){        
        dispatch({
            type: "SHOW_NOTIF",
            payload: { message, type, show: true }
        })   
    }
}
export function cleanNotif(){
    return async function (dispatch){           
        dispatch({
            type: "CLEAN_NOTIF",
            payload: ""
        })
        
    }
}